export const USER_STATUS = {
  ACTIVE: "active",
  LOCKED: "locked",
  PENDING: "pending",
};

export const USER_ROLE = {
  SUPERADMIN: "superadmin",
  SALE: "sale",
  SERVICE: "service",
  MANAGER: "manager",
  SAFETY: "safety",
};

export const PROGRAM_CODE = {
  MASTER_USER: "MT01",
  MASTER_SETTING: "MT02",
  MASTER_CUSTOMER: "MT03",
  MASTER_DOCUMENT_TEMPLATE: "MT04",
  TRANSACTION_JOB: "TS01",
  TRANSACTION_JOB_UPLOAD: "TS02",
  TRANSACTION_JOB_AUTHEN_MANAGER: "TS03",
  TRANSACTION_JOB_AUTHEN_SAFETY: "TS04",
};
